export const NOTIFICATION_CONTEXT = Object.freeze({
    NOTIFICATION_CENTER: 'notification_center',
    NOTIFICATION_BANNER: 'notification_banner',
});
export const EVENT_TYPES = Object.freeze({
    MENTION_STAFF: 'mention.staff',
    IMPORT_NOTIFICATION: 'import.notification',
    THIRD_AUTHORIZATION_ACCEPTED: 'third.authorization.accepted',
    THIRD_AUTHORIZATION_REFUSED: 'third.authorization.refused',
    EMAIL_RECEIVED_NOTIFICATION: 'email.received.notification',
    EMAIL_SEND_ERROR_NOTIFICATION: 'email.send.error.notification',
    AGENDA_ALERT_SENT: 'agendaalert.sent',
});
